import React from 'react'
import { connect } from 'react-redux';
import { login } from '../../actions/login';
import AnalyzePage from '../analyze/analyzePage';
import tonoNormal from '../../res/img/TonoDaruma_01A_03.png';
import tonoAppare from '../../res/img/TonoDaruma_01C_03.png';
import tonoDango from '../../res/img/TonoDaruma_06B_01.png';
import push from 'push.js'
import strings from '../../res/strings';
import TermsPage from '../terms/termsPage';
import stylesPc from './styles/topPageStyle.js'
import stylesPhone from './styles/topPageStyleSmartPhone.js'
import HowtoPage from '../howto/howtoPage';

type Props = {
    dispatch: Function;
};

type State = {
    isLogin: Boolean;
    meetingTime: Number;
    useAssist: Boolean;
    viewTerms: Boolean;
    viewHowTo: Boolean;
};

var styles;
class TopPage extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.containerDiv = React.createRef();
        this.state = {
            isLogin: false,
            viewTerms: false,
            viewHowTo: false,
            meetingTime: 30 * 60,
            useAssist: false,
        };
    }

    login(): Function {
        this.props.dispatch(login())
            .then((res) => {
                this.setState({
                    isLogin: res.login,
                });
            });
        push.Permission.request();
    }

    onChangeTimeRadioButton = () => {
        var tmpTime;
        // if (document.timeRadio.test.checked) {
        //     tmpTime = 1;
        // }
        // else 
        if (document.timeRadio.Radio15.checked) {
            tmpTime = 15;
        } else if (document.timeRadio.Radio30.checked) {
            tmpTime = 30;
        } else if (document.timeRadio.Radio45.checked) {
            tmpTime = 45;
        } else {
            tmpTime = 60;
        }
        this.setState({
            meetingTime: tmpTime * 60,
        });
    }

    onChangeAssistRadioButton = () => {
        var tmpAssist;
        if (document.assistRadio.RadioYes.checked) {
            push.Permission.request();
            tmpAssist = true;
        } else {
            tmpAssist = false;
        }
        this.setState({
            useAssist: tmpAssist,
        })
    }

    viewTerms(): Function {
        this.setState({
            viewTerms: true,
        });
    }
    viewHowTo(): Function {
        this.setState({
            viewHowTo: true,
        });
    }

    renderLoginPage(): Function {
        return (<div style={styles.main}>
            <div style={styles.contentFrame}>
                <button style={styles.howtoText} onClick={() =>this.viewHowTo()}>使い方</button>
                <div style={styles.iconsFrame}>
                    <img style={styles.icon} src={tonoNormal} alt="normal" />
                    <img style={styles.icon} src={tonoAppare} alt="appare" />
                    <img style={styles.icon} src={tonoDango} alt="dango" />
                </div>
                <p style={styles.title}>{strings.appName}</p>
                <p style={styles.subTitle}>リモート会議ついでに気分を測定してみませんか？</p>

                <div style={styles.settingFrame}>
                    <div style={styles.settingItemFrame}>
                        <p style={styles.mettingSettingTitle}>会議時間を設定</p>
                        <form style={styles.radioGroup} name="timeRadio" action="">
                            {/* <input id="test" name="TimeRadioGroup" type="radio" style={styles.radioText} onChange={this.onChangeTimeRadioButton} />
                            <label for="test">test 1分</label><br /> */}

                            <input id="Radio15" name="TimeRadioGroup" type="radio" onChange={this.onChangeTimeRadioButton} />
                            <label htmlFor="Radio15" style={styles.radioText}>15分</label><br />

                            <input id="Radio30" name="TimeRadioGroup" type="radio" onChange={this.onChangeTimeRadioButton} defaultChecked />
                            <label htmlFor="Radio30" style={styles.radioText}>30分</label><br />

                            <input id="Radio45" name="TimeRadioGroup" type="radio" onChange={this.onChangeTimeRadioButton} />
                            <label htmlFor="Radio45" style={styles.radioText}>45分</label><br />

                            <input id="Radio60" name="TimeRadioGroup" type="radio" onChange={this.onChangeTimeRadioButton} />
                            <label htmlFor="Radio60" style={styles.radioText} >60分</label><br />
                        </form>
                    </div>

                    <div style={styles.settingItemFrame}>
                        <p style={styles.mettingSettingTitle}>会議アシスト</p>
                        <form style={styles.radioGroup} name="assistRadio" action="">
                            <input id="RadioYes" name="AssistRadioGroup" type="radio" onChange={this.onChangeAssistRadioButton} />
                            <label htmlFor="RadioYes" style={styles.radioText}>使用する</label><br />

                            <input id="RadioNo" name="AssistRadioGroup" type="radio" onChange={this.onChangeAssistRadioButton} defaultChecked />
                            <label htmlFor="RadioNo" style={styles.radioText}>使用しない</label><br />
                        </form>
                    </div>
                </div>
                <div style={styles.commentFrame}>
                    <p style={styles.comment}>推奨ブラウザ：PC・Android:　Google Chrome / iOS: Safari</p>
                    <p style={styles.comment}>※出力音量が大きいと音声がマイクへ回り込む恐れがあり、ご自身の声をしっかり録音できませんのでお気を付けください。</p>
                </div>
                <div style={styles.buttonsFrame}>
                    <button style={styles.buttonPositive} onClick={() => this.login()}>スタート</button>
                    {/* <a style={styles.buttonNegative} href="https://webempath.com/jpn/">今日はやらない</a> */}
                </div>
            </div>

            <p style={styles.poweredByEmpath}>Powered By Empath</p>

            <div style={styles.links}>
                <div style={styles.link} onClick={() => this.viewTerms()}>利用規約</div>
                <a style={styles.link} href="https://webempath.com/jpn/policy.html" target="_blank" rel="noopener noreferrer">個人情報保護方針</a>
                <a style={styles.link} href="https://webempath.com/jpn/" target="_blank" rel="noopener noreferrer">運営会社</a>
                <a style={styles.link} href="https://webempath.com/jpn/contact/" target="_blank" rel="noopener noreferrer">お問い合わせ</a>
            </div>
        </div>
        );
    }

    render() {
        styles = this.props.screenwidth > 400 * 2 ? stylesPc : stylesPhone;
        if (this.state.isLogin) {
            return (<AnalyzePage
                duration={this.state.meetingTime}
                useAssist={this.state.useAssist} />)
        } else if (this.state.viewTerms) {
            return (<TermsPage />);
        } else if (this.state.viewHowTo) {
            return (<HowtoPage />);
        }
        return this.renderLoginPage();
    }
}
const mapStateToProps = state => ({
    isLogin: state.login.isLogin,
    screenwidth: state.app.screenWidth,
});

export default connect(mapStateToProps)(TopPage);